<script>
  import OptionItem from './OptionItem.svelte';
  import { beforeUpdate, afterUpdate } from 'svelte';
  export let highlight = (text) => text;
  export let options = [];
  export let children = 'children';
  export let multiple = false;
  export let value = '';
  export let hidePopup = false;

  function selectItem(item){
    if (!multiple) {
      value = item.id;			
      hidePopup = true;
    }
  }
  
  function unselectItem(item){
    //TODO
  }
  

  function hideItem(item){
    let hide = false;

    if(multiple && item.selected){
      hide = true;
    } else {
      hide = item.hidden;
    }
    return hide;
  }

</script>

<div class="options">
  {#each options as group}
    {#if !group.hidden}
      <div class="group">
        <span class="group-name">
          {#if group.icon}
            <img src="{group.icon.url}" style="width: 15px; height: 15px" alt=" "/>
          {/if}
          {@html highlight(group.name)}
        </span>
        {#if group.description}
          <br/>
          <p class="group-description text-secondary">
            <small>{group.description}</small>
          </p>
        {/if}

        {#each group[children] as item (item.id)}
          {#if !hideItem(item)}
            <OptionItem 
              item={item} 
              selected={value}
              on:select={() => selectItem(item)}
              on:unselect={() => unselectItem(item)}
              isChild={true}
              {highlight}
            />						
          {/if}
        {/each}
      </div>
    {/if}
  {/each}
</div>

<style>
  .group {
    margin-bottom: 10px;
  }

  .group-name {
    /*font-size: 13px;*/
    font-weight: bold;
    line-height: 14px;
    display: inline-block;
    margin-left: 15px;
  }

  .group-description {
    /*font-size: 10px;*/
    font-weight: lighter;
    line-height: 14px;
    display: inline-block;
    margin-left: 15px;
  }

  .options {max-height: 250px; overflow-y: auto; padding-top: 15px;}

  ::-webkit-scrollbar
  {
    width: 6px;  /* for vertical scrollbars */
    height: 6px; /* for horizontal scrollbars */
  }

  ::-webkit-scrollbar-track
  {
    background: rgba(0, 0, 0, 0.1);
  }

  ::-webkit-scrollbar-thumb
  {
    background: rgba(0, 0, 0, 0.3);
  }




</style>
